<template>
    <div class="app-container py-4">
        <div
                v-if="isUserLoggedIn"
                class="profile-basket profile-inner-page px-0 px-sm-4"
        >
            <v-row class="mx-0">
                <v-col cols="12" md="4" class="hidden-sm-and-down pr-0">
                    <profile-menu @logout="logout" :active-link="3"></profile-menu>
                </v-col>
                <v-col cols="12" md="8">
                    <v-card outlined class="profile-card mb-2 mb-md-3 border-transparent">
                        <v-card-title class="text-uppercase justify-center">{{ metaData.header }}</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text class="py-0">
                            <products-filters @filter-change="filterChange"></products-filters>
                        </v-card-text>
                    </v-card>
                    <v-card outlined class="profile-card mb-2 border-transparent">
                        <products-list
                                :filters="filters"
                        ></products-list>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
    import ProductsFilters from '../../../app-front/components/filters/ProfileProductsFilters';
    import ProductsList from '../../../app-front/components/data-tables/profile-products';
    import ProfileMenu from '../../../app-front/components/profile/menu';
    import RouteAccess from '../../../app-front/mixins/RouteAccess';
    import WatchLogoutRedirect from '../../../app-front/mixins/WatchLogoutRedirect';

    export default {
        name: "ProfileProducts",
        mixins: [
            RouteAccess,
            WatchLogoutRedirect
        ],
        components: {
            ProfileMenu,
            ProductsFilters,
            ProductsList
        },
        data() {
            return {
                filters: {},
                metaUrl: '/profile/products',
            }
        },
        methods: {
            filterChange(filters) {
                this.filters = filters;
            }
        }
    }
</script>

<style scoped>

</style>
